// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import React from "react";

export interface SavedOrderDetailsPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const savedOrderDetailsPageContainerStyles: SavedOrderDetailsPageContainerStyles = {};

const styles = savedOrderDetailsPageContainerStyles;

const SavedOrderDetailsPageContainer = ({ id }: WidgetProps) => {
    const { cartId } = useQueryString();
    const { isEditing } = useShellContext();
    const cartDataView = useCartState(cartId);

    return (
        <PageErrorWrapper
            value={cartDataView}
            extendedStyles={styles.pageErrorWrapper}
            notFoundMessage={siteMessage("Cart_CartNotFound")}
            customErrorMessage={!cartId && !isEditing ? siteMessage("Cart_CartNotFound") : undefined}
        >
            <OrderLayout id={id} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SavedOrderDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Saved Order Details",
        allowedContexts: ["SavedOrderDetailsPage"],
    },
};
export default widgetModule;
